import { Component, inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ButtonPadraoComponent } from "../components/button-padrao/button-padrao.component";
import { SelectOneComponent } from "../components/select-one/select-one.component";

@Component({
  selector: 'app-modal-selecionar-etapa',
  standalone: true,
  templateUrl: './modal-selecionar-etapa.component.html',
  styleUrls: ['./modal-selecionar-etapa.component.css'],
  imports: [ButtonPadraoComponent, SelectOneComponent]
})
export class ModalSelecionarEtapaComponent implements OnInit {

  etapas: any[] = [];
  etapaSelecionada: any;
  tituloFluxo = '';

  public dialogRef = inject<MatDialogRef<ModalSelecionarEtapaComponent>>(MatDialogRef);
  public data = inject(MAT_DIALOG_DATA);

  ngOnInit() {
    this.etapas = this.data?.etapas || [];
    this.tituloFluxo = this.data?.tituloFluxo || '';
  }

  selecionarEtapa(etapa: any){
    this.etapaSelecionada = etapa
  }

  confirmar() {
    this.dialogRef.close(this.etapaSelecionada);
  }

  cancelar() {
    this.dialogRef.close(null);
  }
}
